import React, { useContext } from 'react';
import { Activity, TrendingUp, DollarSign } from 'lucide-react';
import { AppContext } from '../../context/AppContext';
import { REPORT_DATA, formatCurrency } from './AccountReportShared';

const CashFlowPage = () => {
  const { sidebar } = useContext(AppContext);
  const data = REPORT_DATA.cashFlow;
  const calcTotal = (items) => items.reduce((acc, item) => acc + item.value, 0);
  const netCash = calcTotal(data.operating) + calcTotal(data.investing) + calcTotal(data.financing);

  const ActivitySection = ({ title, items, icon: Icon, bgColor, borderColor, iconColor }) => (
    <div className="card border-0 overflow-hidden mb-4" style={{ border: `1px solid ${borderColor}` }}>
      <div className="p-3 border-bottom d-flex align-items-center gap-2" style={{ backgroundColor: bgColor }}>
        <Icon size={18} style={{ color: iconColor }} />
        <h6 className="mb-0 fw-bold" style={{ color: iconColor }}>{title}</h6>
      </div>
      <div>
        {items.map((item, idx) => (
          <div
            key={idx}
            className="d-flex justify-content-between align-items-center p-3 border-bottom"
            style={{ backgroundColor: idx % 2 === 0 ? '#ffffff' : '#fafafa' }}
          >
            <span style={{ fontSize: '0.875rem' }} className="text-dark">{item.name}</span>
            <span className={`font-monospace fw-bold ${item.value < 0 ? 'text-danger' : 'text-success'}`} style={{ fontSize: '0.875rem' }}>
              {item.value < 0 ? `(${formatCurrency(Math.abs(item.value))})` : formatCurrency(item.value)}
            </span>
          </div>
        ))}
      </div>
      <div className="p-3 d-flex justify-content-between align-items-center bg-light">
        <span className="fw-bold text-muted text-uppercase" style={{ fontSize: '0.75rem' }}>Net Cash from {title.split(' ')[0]}</span>
        <span className={`fw-bold font-monospace ${calcTotal(items) < 0 ? 'text-danger' : 'text-success'}`}>
          {formatCurrency(calcTotal(items))}
        </span>
      </div>
    </div>
  );

  return (
    <main className={sidebar ? "taskMain" : "cx-active taskMain"} id="cx-main">
      <div id="sales-main">
        <section className="cx-inneer-header">
          <div className="main-inner">
            <div className="left">
              <label>Cash Flows</label>
            </div>
          </div>
        </section>

        <section className="mt-3">
          {/* Summary Card */}
          <div className="card border-0 mb-4 text-white" style={{ backgroundColor: 'var(--blue_53B7E8_LightMode)', borderRadius: '12px' }}>
            <div className="card-body d-flex justify-content-between align-items-center p-4">
              <div>
                <h4 className="fw-bold mb-0 text-white">Cash Flows</h4>
                <p className="mb-0 text-white-50" style={{ fontSize: '0.875rem' }}>Indirect Method</p>
              </div>
              <div className="text-end">
                <div className="text-white-50 text-uppercase fw-bold" style={{ fontSize: '0.75rem' }}>Net Change in Cash</div>
                <div className="fw-bold fs-3 text-white">{formatCurrency(netCash)}</div>
              </div>
            </div>
          </div>

          {/* Activity Sections */}
          <div className="row">
            <div className="col-12">
              <ActivitySection title="Operating Activities" items={data.operating} icon={Activity} bgColor="#eef2ff" borderColor="#c3dafe" iconColor="#4338ca" />
            </div>
            <div className="col-md-6">
              <ActivitySection title="Investing Activities" items={data.investing} icon={TrendingUp} bgColor="#e0f7fa" borderColor="#b2ebf2" iconColor="#00acc1" />
            </div>
            <div className="col-md-6">
              <ActivitySection title="Financing Activities" items={data.financing} icon={DollarSign} bgColor="#fff8e1" borderColor="#ffecb3" iconColor="#f57c00" />
            </div>
          </div>

          {/* Reconciliation */}
          <div className="card border p-4">
            <div className="d-flex justify-content-between py-2 text-muted">
              <span style={{ fontSize: '0.875rem' }}>Cash at Beginning of Period</span>
              <span className="font-monospace fw-bold">{formatCurrency(139000)}</span>
            </div>
            <div className="d-flex justify-content-between py-3 fw-bold border-top mt-2 fs-6">
              <span>Cash at End of Period</span>
              <span className="font-monospace text-primary">{formatCurrency(139000 + netCash)}</span>
            </div>
          </div>
        </section>
      </div>
    </main>
  );
};

export default CashFlowPage;
